module.exports = __webpack_public_path__ + "img/sfty1.4eab0bab.jpg";